export type WalletChain = "evm" | "solana";

export type DetectedWallet = {
  id: string;
  name: string;
  icon: string | null;
  chain: WalletChain;
};

export type WalletConnection = {
  address: string;
  chainId: number;
};

export type Eip1193Provider = {
  request: (args: { method: string; params?: unknown[] }) => Promise<unknown>;
};

export type SolanaProvider = {
  connect: () => Promise<{ publicKey?: { toString: () => string } } | void>;
  publicKey?: { toString: () => string } | null;
  signMessage: (
    message: Uint8Array,
    encoding?: string,
  ) => Promise<Uint8Array | { signature: Uint8Array }>;
};

export class WalletError extends Error {
  readonly kind: "rejected" | "missing" | "failed";

  constructor(kind: WalletError["kind"], message: string) {
    super(message);
    this.name = "WalletError";
    this.kind = kind;
  }
}
